import { memo } from "react";
import { clsx } from "clsx";
import CheckIcon from "@/common/images/icons/check.svg?react";
import MinusIcon from "@/common/images/icons/minus.svg?react";
import "./Checkbox.scss";

interface ICheckboxProps {
  label?: string;
  size?: "l" | "m" | "s";
  checked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
}

export const Checkbox: React.FC<ICheckboxProps> = memo(({
  label,
  size = "m",
  checked,
  indeterminate,
  disabled,
  onChange,
  name,
  value
}) => {
  return (
    <label className={clsx(
      "Checkbox",
      `Checkbox_${size}`,
      disabled && "Checkbox_isDisabled",
      "Checkbox_isIndet"
    )} htmlFor={name} data-testid="checkbox">
      <input
        type="checkbox"
        name={name}
        value={value}
        id={name}
        aria-label={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <div className="Checkbox-Controls">
        <span
          className="Checkbox-CheckIcon">{indeterminate ? <MinusIcon /> : <CheckIcon />}</span>
        <div className="Checkbox-Control"></div>
      </div>
      {label}
    </label>
  );
});
